module.exports = __webpack_public_path__ + "assets/img/mark_green.65bf7f4b.svg";